import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Flash.svg",
  "use": "Flash.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Flash.svg\"><path d=\"M47.8163,28.1971a1.999,1.999,0,0,1-.321,2.145l-21.9836,25a1.9989,1.9989,0,0,1-3.3756-2.0127L28.14,37.0208H18.0157A2,2,0,0,1,16.5152,33.7l21.9846-25a1.9988,1.9988,0,0,1,3.3756,2.0127L35.871,27.0208H45.9954A1.9969,1.9969,0,0,1,47.8163,28.1971Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol